
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Acbusonrent() {



    const cardData =
    {
        keyword: ' AC Bus On Rent',
        heading: 'Samarth Travels: AC Bus On Rent',
        headingDescription: 'Samarth Travels offers AC bus on rent for a comfortable and hassle-free travel experience, ideal for weddings, corporate events, and group tours. Choose from well-maintained 17 to 50-seater air-conditioned buses driven by professional chauffeurs. With transparent pricing, no hidden charges, and a focus on punctuality and comfort, Samarth Travels ensures smooth journeys for every occasion.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

        "topPlaces": [
             {
                "title": "Sinhagad Fort",
                "description": "Perched atop the Sahyadri hills, Sinhagad Fort is a historic hill fortress located about 30 kilometers from Pune. Famous for the Battle of Sinhagad in 1670, where Maratha warrior Tanaji Malusare fought valiantly, the fort offers breathtaking views, trekking trails, and remnants of ancient military architecture including bastions, gates, and memorials. It's an ideal destination for trekking enthusiasts, history buffs, and nature lovers alike."
            }, 
            {
                "title": "Shaniwar Wada",
                "description": "Shaniwar Wada is one of Pune's most iconic landmarks and a symbol of the Maratha Empire. Built in 1732 as the seat of the Peshwas, this grand fortification features majestic gates, elegant fountains, and intricate architecture. Although much of it was destroyed by fire in 1828, its massive stone walls and legendary tales—especially those surrounding the ghost of Narayanrao—still attract thousands of history lovers and tourists each year."
            },
            {
                "title": "Aga Khan Palace",
                "description": "The Aga Khan Palace is a stunning historical monument built in 1892 by Sultan Aga Khan III. It holds immense national significance due to its association with Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters who were imprisoned here during the Quit India Movement. Set in lush green gardens, the palace showcases Italian arches and spacious halls and also houses a museum with photographs, paintings, and personal belongings of Gandhi, making it a must-visit for those interested in India’s independence movement."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "The Pataleshwar Cave Temple is a unique 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single massive basalt rock, this ancient temple is a fine example of monolithic architecture from the Rashtrakuta period. Its main sanctum houses a linga, and the surrounding sanctum sanctorum includes statues of other deities. Despite being in the middle of the bustling city, it offers a tranquil and spiritual atmosphere for visitors."
            }, 
            {
                "title": "Dagdusheth Halwai Ganpati Temple",
                "description": "This revered Ganesh temple is one of the most visited and richly adorned temples in Maharashtra. Established by a sweet-maker named Dagdusheth Halwai in the late 19th century, the temple is known for its magnificent idol of Lord Ganesh decked in gold and diamonds. The temple draws massive crowds during the Ganesh Chaturthi festival, and its serene ambiance makes it a spiritual haven throughout the year."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "This museum is a treasure trove of Indian heritage and folk art, established by Dr. Dinkar Kelkar in memory of his son. It houses over 20,000 rare and artistic artifacts, including musical instruments, sculptures, paintings, utensils, weaponry, and textiles from all over India. The collection gives a vivid picture of everyday life in bygone eras and is especially appealing to art enthusiasts and cultural historians."
            },
            {
                "title": "Parvati Hill and Temple",
                "description": "Rising 2,100 feet above sea level, Parvati Hill offers panoramic views of Pune city. The hilltop temple complex consists of five main temples, including the Devdeveshwar temple dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa rule, it is not only a religious site but also a peaceful escape from the city buzz. A climb of 103 stone steps leads to the summit, where history and nature meet."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in the serene Koregaon Park area, the Osho International Meditation Resort is a tranquil oasis for seekers of inner peace and mindfulness. Founded by the spiritual guru Osho, it offers daily meditation sessions, yoga programs, and various wellness therapies in a luxurious, Zen-like environment. Visitors from all over the world come here for spiritual growth, rejuvenation, and to experience the calm ambiance of its lush gardens and modern facilities."
            },
            {
                "title": "Pune Okayama Friendship Garden",
                "description": "Also known as Pu La Deshpande Garden, this beautifully landscaped garden is inspired by Japan’s Okayama Korakuen Garden. Spread over 10 acres, it features artistically arranged lawns, water bodies, bridges, and pathways that create a harmonious blend of nature and design. It's a favorite among photography enthusiasts, families, and couples seeking a peaceful retreat amid nature."
            },
            {
                "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
                "description": "This combined facility includes a zoo, snake park, and a wildlife rescue center. The snake park is known for its wide variety of snakes, including the King Cobra and Indian Python, as well as informative exhibits on reptile behavior and conservation. The adjoining zoo is home to tigers, leopards, elephants, and other animals, making it an engaging educational and recreational spot, especially for children and families."
            }
        ],

"services": [
    {
        "name": "Rent AC Bus for Group Travel in Pune",
        "description": "Samarth Travels offers reliable AC bus rental services for group travel in Pune. Whether it's a corporate outing, family reunion, or a friends’ getaway, our air-conditioned buses ensure comfort and convenience for your entire group, providing a smooth and enjoyable journey."
    },
    {
        "name": "AC Bus Rental Services in Pune",
        "description": "Looking for an AC bus rental in Pune? Samarth Travels offers a wide range of AC buses perfect for group tours, corporate trips, and special events. Our fleet is well-maintained, ensuring your travel experience is comfortable, safe, and reliable."
    },
    {
        "name": "Affordable AC Bus Hire in Pune",
        "description": "Samarth Travels offers affordable AC bus hire options in Pune. Perfect for large group travel, family trips, or corporate events, our budget-friendly services ensure you travel in comfort without breaking the bank. Get the best value for your money with our professional bus hire services."
    },
    {
        "name": "Luxury AC Bus Hire Pune",
        "description": "For a premium travel experience, hire a luxury AC bus from Samarth Travels in Pune. Our luxury buses are equipped with high-end amenities, plush interiors, and modern features, making them perfect for weddings, corporate events, and VIP transportation."
    },
    {
        "name": "32-Seater AC Bus Rental Pune",
        "description": "Samarth Travels offers 32-seater AC buses for rent in Pune, ideal for medium-sized group trips. Whether it's a corporate outing, school trip, or family tour, our 32-seater buses provide ample space, comfort, and air-conditioned relaxation for all passengers."
    },
    {
        "name": "AC Bus Hire for Corporate Events in Pune",
        "description": "Make your next corporate event more comfortable with AC bus hire services from Samarth Travels. Our buses are perfect for transporting employees, clients, or guests to and from conferences, team-building events, and corporate picnics in Pune, ensuring a smooth, relaxing journey."
    },
    {
        "name": "Rent a Bus with AC for Family Trips in Pune",
        "description": "Take your family on a comfortable journey with an AC bus from Samarth Travels. Our buses are ideal for family trips around Pune, offering ample space, air-conditioned comfort, and an enjoyable ride for all ages. Perfect for family outings, vacations, or picnics."
    },
    {
        "name": "AC Bus Rental for School Trips in Pune",
        "description": "Samarth Travels provides AC bus rentals for school trips in Pune. Safe, comfortable, and reliable, our buses are perfect for school field trips, educational tours, or excursions. With a focus on student safety and comfort, we ensure every trip is memorable and stress-free."
    },
    {
        "name": "AC Bus Hire for Wedding Functions in Pune",
        "description": "Rent an AC bus for your wedding guests with Samarth Travels. Whether it's for a pre-wedding ceremony, reception, or transportation to the wedding venue, our air-conditioned buses offer the perfect solution for keeping guests comfortable during special occasions."
    },
    {
        "name": "Rent an AC Bus for Outstation Tours from Pune",
        "description": "Planning an outstation trip? Rent an AC bus from Samarth Travels for a comfortable and enjoyable journey from Pune to various destinations. Perfect for long-distance travel, our well-maintained buses ensure a safe, smooth, and cool ride throughout the trip."
    }
],
"tableData": [
    ["Rent AC Bus for Group Travel in Pune", "AC Bus Rental Services in Pune"],
    ["Affordable AC Bus Hire in Pune", "Luxury AC Bus Hire Pune"],
    ["32-Seater AC Bus Rental Pune", "AC Bus Hire for Corporate Events in Pune"],
    ["Rent a Bus with AC for Family Trips in Pune", "AC Bus Rental for School Trips in Pune"],
    ["AC Bus Hire for Wedding Functions in Pune", "Rent an AC Bus for Outstation Tours from Pune"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Non-AC Bus Rental Service for Group Travel",
        "WhyChoosedescription": "Samarth Travels provides dependable and cost-effective non-AC bus rental services for group travel. Whether it’s for school outings, family trips, corporate travel, or any other group event, our non-AC buses are a practical and affordable solution for your transportation needs, ensuring a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Non-AC Buses for Large Groups",
        "WhyChoosedescription": "Our fleet of non-AC buses is ideal for large groups, with seating capacities ranging from 30 to 50+ passengers. The buses are designed for comfort, with spacious seating and ample legroom, ensuring that all passengers enjoy a pleasant journey, whether it's for a short trip or a long-distance adventure."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Safe and Timely Travel",
        "WhyChoosedescription": "Safety is our top priority at Samarth Travels. Our experienced and well-trained drivers ensure that your group travels safely and comfortably. They are familiar with local routes and traffic conditions, ensuring timely arrivals and smooth journeys, making sure you and your group arrive at your destination without any delays."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Non-AC Bus Rentals",
        "WhyChoosedescription": "At Samarth Travels, we understand the importance of sticking to a budget, which is why we offer affordable and transparent pricing for our non-AC bus rental services. With clear, upfront pricing and no hidden charges, you can plan your trip without any surprises, ensuring great value for your money."
    },
    {
        "WhyChooseheading": "Available 24/7 for Flexible Travel Schedules",
        "WhyChoosedescription": "We offer flexible 24/7 availability to suit any travel schedule. Whether you're planning an early morning trip or a late-night return, Samarth Travels can accommodate your needs. Our round-the-clock service ensures that your transportation requirements are met at any time, making sure your journey is convenient and stress-free."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Real-Time Updates",
        "WhyChoosedescription": "Booking your non-AC bus with Samarth Travels is easy and convenient. You can easily book through our website or by contacting our customer support team. Once your booking is confirmed, you’ll receive real-time updates, including live tracking, driver details, and estimated arrival times, ensuring you stay informed during the journey."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Non-AC Buses",
        "WhyChoosedescription": "We take cleanliness seriously. All our non-AC buses are thoroughly cleaned and sanitized before every trip to provide a safe and hygienic environment for your group. Additionally, our buses are regularly maintained and inspected to ensure comfort, safety, and reliability throughout the journey."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Easy Transactions",
        "WhyChoosedescription": "Samarth Travels offers flexible payment options for your non-AC bus rental, including cash, UPI, credit/debit cards, and digital wallets. You can select the payment method that works best for you, ensuring a smooth and hassle-free booking and payment experience."
    }
]
















    }

const faqData = [
    {
        id: 1,
        question: 'How do I rent a Non-AC bus with Samarth Travels?',
        answer: 'Renting a Non-AC bus with Samarth Travels is simple. You can either contact our customer support team or visit our website. Share your travel details like destination, travel dates, and group size, and we’ll recommend the perfect non-AC bus for your needs.',
    },
    {
        id: 2,
        question: 'What types of Non-AC buses are available for rent?',
        answer: 'We offer a variety of Non-AC buses including 22-seater, 32-seater, 40-seater, and 50-seater buses. These buses are ideal for group tours, school trips, and other short-distance travel within Pune and nearby areas.',
    },
    {
        id: 3,
        question: 'Are the Non-AC buses comfortable for long-distance travel?',
        answer: 'Yes, our Non-AC buses are well-maintained and comfortable for both short and long-distance travel. They are equipped with standard seating arrangements and sufficient space for luggage, making them a great budget-friendly option for group travel.',
    },
    {
        id: 4,
        question: 'Can I rent a Non-AC bus for school trips or group outings?',
        answer: 'Yes, Samarth Travels provides Non-AC buses for school trips, group outings, and local tours. These buses are a cost-effective solution for transporting large groups to nearby destinations.',
    },
    {
        id: 5,
        question: 'Is there a one-day rental option for Non-AC buses?',
        answer: 'Yes, we offer flexible one-day rental options for Non-AC buses. Whether you need transportation for a day trip, a corporate outing, or a local event, we can cater to your needs.',
    },
    {
        id: 6,
        question: 'What is included in the Non-AC bus rental cost?',
        answer: 'The rental cost for a Non-AC bus includes the vehicle, driver, and fuel. Additional charges such as tolls, parking, and permits will be communicated upfront, with no hidden fees.',
    },
    {
        id: 7,
        question: 'Do you offer 24/7 service for Non-AC bus rentals?',
        answer: 'Yes, we offer 24/7 service for Non-AC bus rentals. Whether you need a morning departure or late-night return, Samarth Travels ensures timely and reliable transport services at all times.',
    },
];

const testimonials = [
    {
        name: 'Mr. Vikram Patil',
        role: 'Event Coordinator',
        text: 'We booked a 32-seater Non-AC bus for a team outing to Matheran. The bus was comfortable, and the service was prompt. It was a budget-friendly option for our group, and everyone enjoyed the trip.',
        image: '/img/testimonial/testi_2_38.jpg',
    },
    {
        name: 'Mrs. Nisha Sharma',
        role: 'Group Travel Planner',
        text: 'I rented a 50-seater Non-AC bus for a school trip to Alibaug. The booking process was simple, and the bus was spacious with enough room for everyone. A cost-effective solution for large groups.',
        image: '/img/testimonial/testi_2_39.jpg',
    },
];
























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC Bus on Rent",
  "image": "https://samarthtravels.com/assets/images/ac-bus-on-rent.jpg",
  "description": "Rent an AC Bus in Pune for group travel, corporate events, weddings, family trips, school trips, and outstation tours. Affordable and luxury options available, including 32-seater buses with full AC for a comfortable journey.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/ac-bus-on-rent"
  }
};




    return (
        <div>

<Helmet>
  <title>AC Bus on Rent in Pune | 32-Seater, Luxury & Affordable | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent an AC Bus for group travel, corporate events, weddings, and outstation tours in Pune. Affordable and luxury 32-seater options with full AC, including buses for family trips and school tours." 
  />
  <meta 
    name="keywords" 
    content="Rent AC Bus for Group Travel in Pune, AC Bus Rental Services in Pune, Affordable AC Bus Hire in Pune, Luxury AC Bus Hire Pune, 32-Seater AC Bus Rental Pune, AC Bus Hire for Corporate Events in Pune, Rent a Bus with AC for Family Trips in Pune, AC Bus Rental for School Trips in Pune, AC Bus Hire for Wedding Functions in Pune, Rent an AC Bus for Outstation Tours from Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/22.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Acbusonrent;